import { ReadonlyURLSearchParams } from 'next/navigation';

export const generateSearchParams = (
  value: string | number | number[] | string[] | { [key: string]: string | number | null },
  key?: string,
  searchParams?: ReadonlyURLSearchParams,
) => {
  const current = new URLSearchParams(Array.from(searchParams?.entries() || []));

  if (typeof value === 'object' && value !== null) {
    Object.entries(value).forEach(([objectKey, objectValue]) => {
      if (!objectValue) {
        current.delete(objectKey);
      } else {
        current.set(objectKey, objectValue.toString());
      }
    });
  } else if (!key) {
    throw new Error('no valid key');
  } else if (!value) {
    current.delete(key);
  } else if (Array.isArray(value)) {
    current.delete(key);
    value.forEach((item) => {
      current.append(key, item);
    });
  } else {
    current.set(key, value.toString());
  }

  return current;
};
